import { memo } from 'react'

import { getImageUrl } from '@/constants/images'

const Logo = () => (
  <div className="ew-d-flex ew-justify-content-center">
    <img alt="PayUFin logo" height={33} src={getImageUrl('payufin_logo')} width={126} />
  </div>
)

export default memo(Logo)
